export default __webpack_public_path__ + "files/FP8_1_Financial_Instruments_Guarantees.docx";